/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import { push422ErrorsToValidator } from '@helpers/helpers';
import { redirectTo } from '@helpers/url-handler';
import vm from './vue-spa';

vm.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
vm.axios.defaults.headers.common.Accept = 'application/json';
vm.axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').content;

vm.axios.interceptors.response.use((response) => response, (error) => {
    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        push422ErrorsToValidator(error, vm.$validator);

        if (error.response.status === 419) {
            window.showError('', 'Token expired. Please reload the page!', () => window.location.reload());
        } else if (error.response.status === 401) {
            window.showError('', 'You have been disconnected. In order to continue you need to login!', () => redirectTo('/login'));
        } else {
            // window.showError('', error);
        }
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        // window.showError('', error);
    } else {
        // Something happened in setting up the request that triggered an Error
        // window.showError('', error);
    }
    // Do something with response error
    return Promise.reject(error);
});
